// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Modal-ModalBody-module--modal-body--2Oipo"};